import { Typography } from "@packages/ds";
import styled from "styled-components";

export const HeaderWrapper = styled.div`
  display: flex;
  align-items: center;
  margin: 45px 0 32px 0;
`;

export const BaseIcon = styled.div`
  max-height: 40px;
  width: 40px;
  margin-right: 20px;
  img {
    max-height: 100%;
    max-width: 100%;
    object-fit: contain;
  }
`;

export const TemplateInfo = styled(Typography.BodyText)<{ isEmpty: boolean }>`
  margin-bottom: 24px;
  margin-bottom: ${({ isEmpty }) => (isEmpty ? "48px" : "24px")};
  & p {
    margin-top: 0;
    margin-bottom: 5px;
  }
`;

export const Subtitle = styled(Typography.BodyText)`
  margin-bottom: 4px;
`;

export const ActionLinks = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;
